/*
DO NOT EDIT 'ui-current-theme.ts' directly.

Instead, make changes to 'ui-current-theme.ts.template', which will then be copied to 'ui-current-theme.ts' by Parcel bundler.
*/
export const currentUITheme = 'LDS';
